// extracted by mini-css-extract-plugin
export default {"inputBox":"userCard_inputBox__8sazm","img":"userCard_img__kVTl2","userBox":"userCard_userBox__JYUuJ","userCard":"userCard_userCard__Rbjg8"};